var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTiresFrontAxle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 211.766,
    height: 99.212,
    viewBox: "0 0 211.766 99.212",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 58.496c.49-.04.69-.42.72-.8.42-5.28 3.79-9.04 6.74-12.99 3.39-4.53 8.43-6.52 13.54-8.28 7.27-2.51 14.88-3.65 22.34-5.36 5.61-1.28 10.45-3.58 15.06-7.27 15.08-12.08 32.03-20.38 51.41-23.04 11.45-1.57 22.88-.36 34.29.63 11.03.95 21.88 3.06 32.73 5.19 1.56.31 3.15.46 4.73.55 3.19.19 4.88 1.59 4.89 4.76 0 1.79.85 2.65 2.01 3.66 4.16 3.67 9.02 6.64 11.84 11.67.37.65.9.72 1.5.68 3.35-.23 4.64 1.96 5.13 4.69.63 3.52 1.2 7.09 1.36 10.65.26 5.72 1.9 11.14 3.04 16.68.96 4.68.3 9.34-1.63 13.74-1.78 4.06-4.84 6.72-9.11 8.02-1.65.5-2.36.56-2.28-1.72.39-12.05-9.26-22.28-21.1-22.64-12.08-.37-22.11 8.9-22.74 21.03 0 .1 0 .2-.02.3-.29 1.65 1.13 3.97-.05 4.77-1.35.91-3.63.52-5.5.56-26.89.63-53.79 1.21-80.68 1.89-2.23.06-2.52-.45-2.1-2.6 1.73-8.99-2.2-17.69-9.95-22.64-7.14-4.55-16.96-4.48-23.72.38-7.85 5.66-11.2 13.32-9.19 22.9.52 2.46.04 2.89-2.32 2.94-3.28.08-6.54.33-9.83-.06-4.77-.56-8.71-2.36-11.1-6.77v-21.53l-.01.01z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.36 61.496c4.91 2.11 9.67 4.33 12.26 9.51 3.53 7.07 3.24 13.92-1.4 20.26-4.79 6.54-11.55 9.07-19.46 7.49-8.04-1.61-13.07-6.71-15.11-14.72-1.98-7.77 2.41-19.53 14.08-22.55 1.03-.47 2.12-.23 3.19-.29 1.08-.06 2.15-.06 3.23 0 1.07.06 2.17-.19 3.21.29v.01z",
    fill: "#EFDF00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M176.34 60.715c10.35-.05 18.63 8.34 18.63 18.85 0 9.9-8.59 18.31-18.65 18.27-10.04-.04-18.52-8.5-18.48-18.44.04-10.35 8.24-18.63 18.5-18.68z",
    fill: "#000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.12 61.406h-3.15c-.16-.22-.12-.4.14-.51.95-.39 1.91-.41 2.86 0 .18.07.26.17.25.3-.02.14-.06.21-.1.21z",
    fill: "#C09102"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.12 60.896c-.05.17-.1.34-.14.51l-3.24.09c1-.9 2.21-.62 3.38-.59v-.01z",
    fill: "#866F28"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M46.12 61.406c-.04-.17-.08-.34-.14-.51 1.16-.01 2.38-.34 3.38.6l-3.24-.09z",
    fill: "#856D26"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiresFrontAxle);
export default __webpack_public_path__ + "static/media/tires-front-axle.1d9da48c21a7dffcec3298767e9bb6bc.svg";
export { ForwardRef as ReactComponent };